import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useStyles } from "./LoginStyle";
import { useNavigate } from "react-router-dom";
import { loginUserName } from "../../store/actions/AuthAction";
import {useDispatch } from "react-redux";
import { toast } from 'react-toastify';

export default function Login() {
  const styles = useStyles();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const [username, setUsername] = useState("");

  const data = {
    username
  };



  const handleOnSubmit = () => {
    if (username==='') {
      toast.error('Enter Email Or UserName ')
      
    } else {
      navigate(`/password`);
      dispatch(loginUserName(setLoading, data));
    }
   
  };

  return (
    <div className={styles.MainPage}>
      <div className={styles.LoginContainer}>
        <div className={styles.LoginHeading}>
          <h1 className={styles.text}>LOGO HERE</h1>
        </div>
        <div className={styles.InlineHeaderContainer}>
          <p className={styles.HeaderdHeading}>Log in to console</p>
          <p className={styles.InputFieldHeading}>Email ID</p>

          <div className={styles.IconAndInputField}>
            <input
              onChange={(e) => setUsername(e.target.value)}
              type="email"
              className={styles.Input}
              placeholder="Enter Your Email"
            />
          </div>
          
            <div className={styles.ButtonContainer}>
              <button onClick={handleOnSubmit} className={styles.LoginButton}>
                Next
              </button>
            </div>
        
          <div className={styles.NewUserContainer}>
            <p className={styles.NewUserText}>New User?</p>
            <p className={styles.ForgotText}>Forgot password?</p>
          </div>
        </div>
      </div>
    </div>
  );
}
